function areaSearchRules(app) {
  return {

    // オーナーEXID チェック  ・桁数チェック  ・必須チェック  ・型チェック
    ownerExId: [
      {
        max: 20,
        trigger: 'change',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.area.search.ownerId'),
          length: 20
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'change',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.system.area.search.ownerId'),
          type: '半角英数字'
        })
      }
    ],
    // オーナー名 チェック  ・桁数チェック  ・必須チェック  ・型チェック
    ownerName: [
      {
        max: 50,
        trigger: 'change',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.area.search.ownerName'),
          length: 50
        })
      }
    ],

    // ビルEXID チェック  ・桁数チェック  ・必須チェック  ・型チェック
    buildingExId: [
      {
        max: 20,
        trigger: 'change',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.area.search.buildingId'),
          length: 20
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'change',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.system.area.search.buildingId'),
          type: '半角英数字'
        })
      }
    ],

    // ビル名 チェック  ・桁数チェック  ・必須チェック  ・型チェック
    buildingName: [
      {
        max: 50,
        trigger: 'change',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.area.search.buildingName'),
          length: 50
        })
      }
    ],

    // フロア チェック  ・桁数チェック  ・必須チェック
    floor: [
      {
        max: 50,
        trigger: 'change',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.area.search.floor'),
          length: 50
        })
      }
    ],

    // エリア名 チェック  ・桁数チェック  ・必須チェック  ・型チェック
    areaName: [
      {
        max: 50,
        trigger: 'change',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.area.search.areaName'),
          length: 50
        })
      }
    ]

  }
}

export default {
  areaSearchRules: areaSearchRules
}
